import { useContext } from 'react';
import { Grid, Typography, Link, Stepper, Step, StepLabel, Button, colors } from '@material-ui/core';
import { DateTime } from '../../../common';
import { HistoryContext } from '../HistoryContext';
import { NavContext, NavRoutes } from '../../../contexts';
import { RequestStatus } from '../../../../helpers';
import GetAppIcon from '@material-ui/icons/GetApp';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2)        
    },
    history: {
        marginBottom: theme.spacing(1)
    },
    date: {

    },
    time: {
        marginLeft: "6px"
    },
    exportButton: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2)
    },
    notes: {
        color: colors.blue[500],
        marginLeft: "4px"       
    },
    urlContainer: {
        cursor: "pointer"
    },
    urlBody: {
        textDecoration: "underline"
    }
}));

export const RequestHistory = (props) => {
    const classes = useStyles();
    const { requestId } = useParams();
    const { navigateTo } = useContext(NavContext);

    const {
        state,
        downloadHistory,
        isDownloading
    } = useContext(HistoryContext);

    const getHistoryStatusText = (status) => {
        switch(status) {
            case RequestStatus.Draft:
                return "Draft";
            case RequestStatus.ToBeReviewed:
                return "To Be Reviewed";
            case RequestStatus.BossApproval:
                return "Boss Approval";
            case RequestStatus.CreditRiskEvaluation:
                return "Credit Risk Evaluation";
            case RequestStatus.CreditRiskReEvaluation:
                return "Credit Risk Re Evaluation";    
            case RequestStatus.CreditRiskApproval:
                return "Credit Risk Approval";
            case RequestStatus.Logistic:
                return "Logistic";
            case RequestStatus.WaitingForContract:
                return "Waiting For Contract";
            case RequestStatus.PricingUnit:
                return "Pricing Unit";
            case RequestStatus.AccountReceivableApproval:
                return "Account Receivable Approval";
            case RequestStatus.WaitingToBeAddedInSap:
                return "Waiting To Be Added In Sap";
            case RequestStatus.SapError:
                return "Sap Error";
            case RequestStatus.Approved:
                return "Approved";
            case RequestStatus.Rejected:
                return "Rejected";
            case RequestStatus.Deleted:          
                return "Deleted";
            case RequestStatus.Blocked:          
                return "Blocked";
            case RequestStatus.Closed:          
                return "Closed";
            default:
                return "Unknown";
        }
    };

    const getHistoryNoteText = (note) => {
        if (note.includes("|"))
            note = note.split("|").map((x, index) => <div key={index}>{x}</div>);

        return (
            <Typography className={classes.notes} variant="caption" component="span">
                <br/>{note}&nbsp;
                {
                    note.indexOf("SAP Error") !== -1 &&
                    <span
                        className={classes.urlContainer}
                        onClick={() =>
                            window.open(state.history.sapErrorGuideUrl, "_blank")
                        }
                    >
                        (<span className={classes.urlBody}>
                            open the guide to better understand this error
                        </span>)
                    </span>
                }
            </Typography>
        );
    }

    const getSteps = (history) => {
        if (history.statusChanges !== null && history.statusChanges.length > 0) {
            return history.statusChanges.map((change, index: number): JSX.Element =>
                <Step key={index} color="primary">
                    <StepLabel
                        optional={
                            <>
                                <Typography variant="caption" className={classes.date}>
                                    <DateTime value={change.changeDate} date />
                                </Typography>
                                <Typography variant="caption" className={classes.time}>
                                    <DateTime value={change.changeDate} time />
                                </Typography>
                                <Typography variant="caption" component="span">
                                    &nbsp; by {change.doerFullName || "Unknown"}
                                </Typography>    
                            </>
                        }>

                        {
                            index > 0 &&
                            `${getHistoryStatusText(history.statusChanges[index - 1].status)} -> `
                        }

                        {getHistoryStatusText(change.status)}

                        {change.note && getHistoryNoteText(change.note)}
                    </StepLabel>
                </Step>
            );
        }
    }    

    return (
        <Grid container className={classes.root}>
            <Grid item xs={12}>
                <Link
                    component="button"
                    variant="caption"
                    className={classes.history}
                    onClick={() => {
                        navigateTo(NavRoutes.EditRequest, [state.history.customerRequestId])
                    }}>
                    Go back to the request
                </Link>      

            </Grid>
            <Grid item xs={12}>
                <Button
                    className={classes.exportButton}
                    disabled={isDownloading}
                    type="button" 
                    variant="outlined"
                    onClick={() =>
                        downloadHistory(requestId, state.requestDbType)
                    }
                >
                    <GetAppIcon/>&nbsp;Export Excel
                </Button>                
            </Grid>            
            {state.history 
                && state.history.statusChanges
                && state.history.statusChanges.length > 0 &&                
                <Grid item xs={12}>
                    <Stepper orientation="vertical" activeStep={state.history.statusChanges.length - 1}>
                        {getSteps(state.history)}
                    </Stepper>
                </Grid>
            }
        </Grid>
    );
}